import React from 'react';

import utility from '../../services/utility';
import { Input, InputGroup, InputGroupAddon } from 'reactstrap';

const FormDateTimeZone = ({ dateValue, forwardedRef, ...rest }) => {
    return <InputGroup>
        <Input
            ref={forwardedRef}
            {...rest}
        />
        <InputGroupAddon addonType="append">{
            utility.formatTime(dateValue) || utility.formatTimeZone(Date.now())
        }
        </InputGroupAddon>
    </InputGroup>
}
export default FormDateTimeZone;